function ExperienceItem({ title, company, period, highlights }) {
  return (
    <div className="bg-surface-card p-5 sm:p-8 rounded-xl border border-surface-border shadow-lg transition-colors hover:border-accent-cyan/40">
      <div className="flex flex-col gap-1 sm:flex-row sm:items-start sm:justify-between sm:gap-4 mb-4">
        <div>
          <h3 className="text-xl font-semibold sm:text-2xl">{title}</h3>
          <p className="text-accent-violet italic">{company}</p>
        </div>
        <p className="text-sm text-accent-cyan shrink-0">{period}</p>
      </div>
      <ul className="space-y-2 text-gray-300 text-sm sm:text-base leading-relaxed">
        {highlights.map((item) => (
          <li key={item} className="flex gap-2">
            <span className="text-accent-cyan shrink-0 mt-1.5">▸</span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function Experience() {
  return (
    <section className="border-t border-surface-border px-5 py-14 sm:px-12 sm:py-20">
      <h2 className="text-3xl font-bold mb-2 sm:text-4xl sm:mb-3">
        <span className="text-gradient">Experience</span>
      </h2>
      <p className="text-gray-400 mb-8 sm:mb-10 text-sm sm:text-base">Where I've worked</p>
      <div className="space-y-6 sm:space-y-8">
        <ExperienceItem
          title="Full-Stack Developer Intern"
          company="BharatGo (Megapod Techworks Pvt. Ltd.)"
          period="Mar 2026 — Present"
          highlights={[
            "Built an AI-powered vendor analytics chatbot using AWS Lambda and Amazon Bedrock Converse API with tool-calling, integrating Amazon Nova and Claude Haiku LLMs to answer natural language business analytics queries.",
            "Integrated AI capabilities into production workflows using prompt engineering, backend APIs and AWS cloud services.",
            "Developed and debugged production features across a multi-tenant Shopify-style SaaS platform using Next.js, React, Node.js, Express.js and PostgreSQL.",
            "Resolved production issues involving Redux state management, asynchronous API communication, database queries and dynamic UI rendering.",
            "Worked extensively with AWS EC2, Lambda, S3, RDS, Amplify, ACM and Secrets Manager in a production environment.",
            "Collaborated in Agile development, code reviews, Git workflows and production troubleshooting.",
          ]}
        />
      </div>
    </section>
  );
}
